import { ReactElement, useEffect, useRef } from 'react';
import { MapContainer } from '../Map/MapContainer';
import { MapContent } from '../Map/MapContent';
import { useHealthDataContext } from '../contexts/HealthDataContext';

interface HealthMapProps {
  hasHealth: boolean;
  loading: boolean;
}

export function HealthMap({
  hasHealth,
  loading,
}: Readonly<HealthMapProps>): ReactElement {
  const { units, loading: loadingHealth } = useHealthDataContext();
  const isFirstUnitsRender = useRef(true);

  const disabledComponents = loadingHealth || isFirstUnitsRender.current || !hasHealth;

  useEffect(() => {
    if (loadingHealth && isFirstUnitsRender.current) {
      isFirstUnitsRender.current = false;
    }
  }, [loadingHealth]);

  useEffect(() => () => {
    isFirstUnitsRender.current = true;
  }, []);

  return (
    <MapContainer
      loading={loading}
      disabledTooltip={disabledComponents}
    >
      <MapContent
        type="health"
        disabled={disabledComponents}
        units={units}
      />
    </MapContainer>
  );
}
